import React from "react";
import {
  IoFileTrayStackedOutline,
  IoLogOutOutline,
  IoNewspaperOutline,
  IoPeopleOutline,
} from "react-icons/io5";
import { Route, Routes } from "react-router-dom";
import { PagePath } from "../../navigation/routes";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { logoutUser } from "../../store/user/thunks/logoutUser";
import { isAdmin, isCurator } from "../../utils/userPermissions";
import { HeaderItem, LogoutHeaderItem, HeaderSeparator } from "./HeaderItem";
import { HeaderRowStyled, HeaderStyled, HeaderSubPlaceholder } from "./styled/Header.styled";
import { DataImportSubNav } from "./subNav/DataImportSubNav";
import { ParsingSubNav } from "./subNav/ParsingSubNav";
import { ReportsSubNav } from "./subNav/ReportsSubNav";
import { TicketGridsSubNav } from "./subNav/TicketGridsSubNav";

export function Header() {
  const dispatch = useAppDispatch();
  const userType = useAppSelector((s) => s.user.info?.type);
  const isAdminUser = isAdmin(userType);
  const isCuratorUser = isCurator(userType);

  return (
    <HeaderStyled>
      <HeaderRowStyled>
        {!isCuratorUser ? (
          <>
            <HeaderItem path={PagePath.parsing.jobs}>
              <IoNewspaperOutline />
              Сбор данных
            </HeaderItem>
          </>
        ) : null}

        <HeaderItem path={PagePath.ticketGrids.templates} notReady={false}>
          <IoFileTrayStackedOutline />
          Билетные сетки
        </HeaderItem>
        {!isCuratorUser ? (
          <>
            <HeaderItem path={PagePath.reports.templates} notReady={false}>
              <IoFileTrayStackedOutline />
              Отчеты
            </HeaderItem>
            <HeaderItem path={PagePath.dataImport.association.hotels}>
              <IoFileTrayStackedOutline />
              База данных
            </HeaderItem>
          </>
        ) : null}
        {isAdminUser ? (
          <>
            <HeaderSeparator />
            <HeaderItem path={PagePath.users}>
              <IoPeopleOutline />
              Пользователи
            </HeaderItem>
          </>
        ) : null}
        <HeaderSeparator />
        <LogoutHeaderItem path={PagePath.login} onClick={() => dispatch(logoutUser())}>
          <IoLogOutOutline />
          Выйти
        </LogoutHeaderItem>
      </HeaderRowStyled>

      <Routes>
        <Route path={PagePath.parsing.root} element={<ParsingSubNav />} />
        <Route path={PagePath.ticketGrids.root} element={<TicketGridsSubNav />} />
        <Route path={PagePath.reports.root} element={<ReportsSubNav />} />
        <Route path={PagePath.dataImport.root} element={<DataImportSubNav />} />
        <Route path={"/*"} element={<HeaderSubPlaceholder />} />
      </Routes>
    </HeaderStyled>
  );
}
